// extracted by mini-css-extract-plugin
export default {"aryaCertifiedCSS":"styles_aryaCertifiedCSS__lOpEq","border-left-rad-not-rouned":"styles_border-left-rad-not-rouned__th+my"};